import { IModel, Model } from './model'

export interface IReference extends IModel {
  url: string | null
  description: string | null
}

export class Reference extends Model implements IReference {
  public url: string | null = null
  public description: string | null = null
}
